import styled from "styled-components";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
  align-items: center;
  height: 100%;
  width: 100%;
`;

export const ButtonListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1450px;
  padding-inline: 25px;
`;

